var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M473.655,423.724H38.345C17.167,423.724,0,406.557,0,385.38V126.622 c0-21.177,17.167-38.345,38.345-38.345h435.31c21.177,0,38.345,17.167,38.345,38.345V385.38 C512,406.557,494.833,423.724,473.655,423.724z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M8.828,256h238.345c4.875,0,8.828-3.953,8.828-8.828V97.104c0-4.874-3.95-8.826-8.825-8.828H38.345 C17.167,88.277,0,105.444,0,126.622v120.552C0,252.048,3.953,256,8.828,256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M8.828,256h15.334l81.77-53.574V256h44.138v-53.574L231.839,256h15.334 c4.875,0,8.828-3.953,8.828-8.828v-7.002l-70.154-45.963H256V150.07h-70.155L256,104.107v-7.002c0-4.875-3.95-8.826-8.825-8.828 h-15.337l-81.769,53.574V88.277h-44.138v53.574L26.844,90.035c-9.234,2.9-16.954,9.203-21.711,17.434l65.023,42.601H0v44.138h70.155 L0,240.171v7.002C0,252.048,3.953,256,8.828,256z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "256,158.898 141.241,158.898 141.241,88.277 114.759,88.277 114.759,158.898 0,158.898  0,185.38 114.759,185.38 114.759,256 141.241,256 141.241,185.38 256,185.38  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M8.227,102.903l72.662,47.167h16.214L14.607,96.52C12.238,98.39,10.097,100.533,8.227,102.903z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M166.283,150.07l88.374-57.366c-1.536-2.599-4.246-4.427-7.485-4.427h-1.909l-95.194,61.793H166.283 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M89.474,194.208L1.269,251.464C2.79,254.126,5.542,256,8.828,256h1.665l95.196-61.793H89.474z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M255.86,247.866l-82.666-53.658H156.98l93.874,60.935 C253.666,253.838,255.595,251.103,255.86,247.866z"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#41479B"
    },
    cx: 128,
    cy: 172.141,
    r: 26.483
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M129.788,150.668l4.425,13.266l13.984,0.108c1.811,0.014,2.561,2.325,1.105,3.4l-11.25,8.307 l4.218,13.333c0.546,1.726-1.419,3.154-2.892,2.101L128,183.053l-11.377,8.131c-1.473,1.053-3.438-0.375-2.892-2.101l4.218-13.333 l-11.25-8.307c-1.457-1.076-0.706-3.386,1.105-3.4l13.984-0.108l4.425-13.266C126.785,148.951,129.215,148.951,129.788,150.668z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M56.501,161.475l2.379,7.133l7.519,0.058c0.973,0.008,1.377,1.25,0.594,1.828l-6.048,4.467 l2.268,7.168c0.294,0.928-0.764,1.696-1.555,1.13l-6.116-4.372l-6.116,4.372c-0.792,0.566-1.848-0.202-1.555-1.13l2.268-7.168 l-6.048-4.467c-0.783-0.578-0.38-1.821,0.594-1.828l7.519-0.058l2.379-7.133C54.888,160.551,56.193,160.551,56.501,161.475z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M202.086,161.475l2.379,7.133l7.519,0.058c0.973,0.008,1.377,1.25,0.594,1.828l-6.048,4.467 l2.268,7.168c0.294,0.928-0.764,1.696-1.555,1.13l-6.116-4.372l-6.116,4.372c-0.792,0.566-1.848-0.202-1.555-1.13l2.268-7.168 l-6.048-4.467c-0.783-0.578-0.38-1.821,0.594-1.828l7.519-0.058l2.379-7.133C200.472,160.551,201.778,160.551,202.086,161.475z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M129.075,107.895l2.379,7.133l7.519,0.058c0.973,0.008,1.377,1.25,0.594,1.828l-6.049,4.466 l2.268,7.168c0.294,0.928-0.764,1.696-1.555,1.13l-6.116-4.372l-6.116,4.372c-0.792,0.566-1.848-0.202-1.555-1.13l2.268-7.168 l-6.048-4.467c-0.783-0.578-0.38-1.821,0.594-1.828l7.519-0.058l2.379-7.133C127.46,106.971,128.767,106.971,129.075,107.895z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M129.075,216.316l2.379,7.133l7.519,0.058c0.973,0.008,1.377,1.25,0.594,1.828l-6.049,4.466 l2.268,7.168c0.294,0.928-0.764,1.696-1.555,1.13l-6.116-4.372l-6.116,4.372c-0.792,0.566-1.848-0.202-1.555-1.13l2.268-7.168 l-6.048-4.467c-0.783-0.578-0.38-1.821,0.594-1.828l7.519-0.058l2.379-7.133C127.46,215.393,128.767,215.393,129.075,216.316z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNu);
export default __webpack_public_path__ + "static/media/nu.20df327da74d6df99a9742280ae99f8f.svg";
export { ForwardRef as ReactComponent };